import { parameterize } from '../parameterize';
import { mergeReduce } from '../parse/merge';
import entries from 'lodash/entries';
import mapKeys from 'lodash/mapKeys';

/**
 * Will construct an API url from a given list of allowed parameters and the
 * parameters requested. If a parameter isn't allowed, it is filtered out.
 *
 * @param {string|function} path
 *
 * @param {string} path - a string path. Eg. `/accounts/me`
 * @param {string[]} allowed - an array of the allowed parameters of the query
 *     string or post body.
 * @param {object} requested - the object containing all of this request's parameters.
 * return {string} the url to the api endpoint
 */

export default function buildApiUrl(
  path: string = '',
  allowed: string[] = [],
  forced: any = {},
  requested: any = {},
): string {
  let params = '';
  // remove `[]` at the end in the params if already present
  // this is to support rails style query params(filter)
  requested = mapKeys(requested, (value, key) => key.replace(/\[\]$/g, ''));

  if (allowed.length) {
    params = parameterize(
      entries(requested)
        .filter(([k, v]) => allowed.includes(k))
        .map(([k, v]) => ({ [k]: v }))
        .reduce(mergeReduce, {}),
    );
  }

  if (Object.keys(forced).length > 0) {
    params += `${params.length > 0 ? '&' : ''}${parameterize(forced)}`;
  }

  return !params.length ? path : `${path}?${params}`;
}
